var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShareCopylink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13H10.3333C9.598 13 9 13.598 9 14.3333V21C9 21.7353 9.598 22.3333 10.3333 22.3333H17C17.7353 22.3333 18.3333 21.7353 18.3333 21V14.3333C18.3333 13.598 17.7353 13 17 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H14.3333C13.9797 9 13.6406 9.14048 13.3905 9.39052C13.1405 9.64057 13 9.97971 13 10.3333V11.6667H18.3333C18.687 11.6667 19.0261 11.8071 19.2761 12.0572C19.5262 12.3072 19.6667 12.6464 19.6667 13V18.3333H21C21.3536 18.3333 21.6928 18.1929 21.9428 17.9428C22.1929 17.6928 22.3333 17.3536 22.3333 17V10.3333C22.3333 9.97971 22.1929 9.64057 21.9428 9.39052C21.6928 9.14048 21.3536 9 21 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareCopylink);
export default __webpack_public_path__ + "static/media/icon_share_copylink.5045d9e29efd4808d1925bc279335db3.svg";
export { ForwardRef as ReactComponent };